import React, { Component } from 'react'
import Meta from 'components/layout/Meta';
import {actions} from "components/page/pageModule";

import './index.scss'

class JiQiRen extends Component {

  constructor(props) {
    super(props)
  }

  render() {

    return (
      <div className="servicesWrap">
        <Meta location={this.props.location} title=""/>
        <div className="banner jqr_banner">
          <div className="banner_cont">
            <h1>智能语音机器人</h1>
            <p>为金融、教育、招聘、互联网等行业量身定制，提供AI电话外呼，意向客户精确筛选，解决客户难题。</p>
            <a href="./services/submitform">方案咨询</a>
          </div>
        </div>
        <div className="wrapPanel">
          <div className="panel jqr_panel">
            <h2><span>产品特色</span></h2>
            <ul className="jqr_pro_ul">
              <li>
                <img src={require('./images/icon_1.png')}/>
                <p>基于NLP、机器学习等前沿科技，对答如流</p>
                <span className="cont">运用先进的语音识别、语义理解、语音合成及深度学习算法，在听清并准确理解说话人意图的基础上，智能语音机器人可自然流畅地与人对话。</span>
              </li>
              <li>
                <img src={require('./images/icon_2.png')}/>
                <p>支持打断、支持转人工、支持短信发送，多措并举保证效果</p>
                <span className="cont">智能语音机器人说话时，客户可打断插话，机器人可根据对插话内容的理解调整应答内容，支持转人工及发送短信，以最大限度保证沟通效果。</span>
              </li>
              <li>
                <img src={require('./images/icon_3.png')}/>
                <p>关键信息完整记录，客户意向精准识别</p>
                <span className="cont">基于对通话内容的深入理解，根据严谨的意向规则，系统自动对客户意向进行归类，精准地为客户打上各种细分的意向标签。</span>
              </li>
            </ul>
            <ul className="jqr_pro_ul">
              <li>
                <img src={require('./images/icon_1.png')}/>
                <p>实时监控与统计分析并重，降低日常运营风险，洞悉优化方向</p>
                <span className="cont">实时监控任务执行情况，密切关注任务状态、拨打数据、接通率、未接通数据及其构成等，及时发现异常，降低日常运营风险及损失；持续分析通话时长、对话轮次、意向等级结构变动等数据，为后续调优做准备。</span>
              </li>
              <li>
                <img src={require('./images/icon_2.png')}/>
                <p>支持自定义A/B Test，高效甄别最优方案</p>
                <span className="cont">系统支持运用基于各类变量的分组规则对测试名单进行自定义分组，话术、通话策略等灵活配置，A/B Test结果自动分析，最优方案快速识别。</span>
              </li>
              <li>
                <img src={require('./images/icon_3.png')}/>
                <p>集成智能质检、舆情监测，严防合规风险及客诉隐患</p>
                <span className="cont">根据事先设定的规则及策略，100%覆盖所有通话内容，高效识别关键词、敏感词及客户情绪波动等，保证合规经营及客户体验。</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="wrapPanel panelCol">
          <div className="panel jqr_panel">
            <h2><span>应用领域</span></h2>
            <ul className="panel_ul">
              <li>
                <p className="title">金融</p>
                <img src={require('./images/icon_1.png')}/>
                <p>电话客服；客户回访、关怀；促销活动介绍贷款；信用卡、保险等营销；客户完件、复贷促动</p>
              </li>
              <li>
                <p className="title">教育</p>
                <img src={require('./images/icon_2.png')}/>
                <p>课程推广；试听邀约；活动推荐；课程质量回访、意见收集</p>
              </li>
            </ul>
            <ul className="panel_ul">
              <li>
                <p className="title">房地产</p>
                <img src={require('./images/icon_1.png')}/>
                <p>地产营销；装修装饰营销；物业费催缴；物业重要通知（停水停电等）</p>
              </li>
              <li>
                <p className="title">医疗</p>
                <img src={require('./images/icon_2.png')}/>
                <p>预约确认、提醒；医疗美容营销；活动促销；客户回访</p>
              </li>
            </ul>
          </div>
        </div>
        <div className="wrapPanel">
          <div className="panel jqr_panel">
            <h2><span>应用领域</span></h2>
            <table>
              <thead>
                <tr><th></th><th>智能机器人</th><th>人工坐席</th></tr>
              </thead>
              <tbody>
                <tr><th>日拨打量</th><td>800-1200</td><td>200-300</td></tr>
                <tr><th>年工作天数</th><td>全年无休</td><td>250天（节假日休息）</td></tr>
                <tr><th>年拨打量</th><td>约40万</td><td>约7.5万</td></tr>
                <tr><th>工作状态</th><td>稳定、高效</td><td>情绪化</td></tr>
                <tr><th>管理难度</th><td>低</td><td>高（培训成本高，人员流动性大等）</td></tr>
                <tr><th>信息记录/数据统计</th><td>完整、客观</td><td>缺失、主观</td></tr>
                <tr><th>客户跟进</th><td>归类标准清晰，便于跟进</td><td>记录混乱，跟进难度大，易流失</td></tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="wrapPanel panelCol">
          <div className="panel pro_panel">
            <h2><span>服务方式及流程</span></h2>
            <img src={require('./images/pro_2.png')}/>
            <ul>
              <li>试用体验</li>
              <li>签署服务协议</li>
              <li>组建服务团队</li>
              <li>沟通需求、定制解决方案</li>
              <li>测试、上线</li>
              <li>售后服务与支持</li>
            </ul>
          </div>
        </div>
      </div>
    )
  }
}


export default JiQiRen



// WEBPACK FOOTER //
// ./modules/services/JiQiRen.js